// import external dependencies
import 'jquery';
// Import IE11 polyfill for opening modals - has to be before bootstrap
// import './polyfill-objects-assign.js';
// NOTE: instead of this polyfill we test using https://polyfill.io polyfill which is loaded in the /layouts/app.blade.php
// TODO: Remove the above commented out code after 1st of May
// Import everything from autoload
import './autoload/_bootstrap.js';
import common from './routes/common';
import home from './routes/home';
// import local dependencies
import Router from './util/Router';
// console.log('test1234');

/** Populate Router instance with DOM routes */
const routes = new Router({
    // All pages
    common,
    // Home page
    home,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js